import React from 'react'
import { useLocation } from 'react-router-dom'

import { routes } from '@sketch/constants'

import Navbar from 'components/Navbar'
import { Text, Link } from '@sketch/components'
import { ConnectedUserDropdown } from 'modules/user/components/UserNavbarSection/UserDropdown'

import { Header, LogoWrapper, HeaderLinkButton } from './IndexLayout.styles'

const headerLinkProps = {
  'sign-up': {
    link: routes.SIGN_UP.create({}),
    text: 'New to Sketch?',
    buttonCopy: 'Create an Account',
  },
  'sign-in': {
    link: routes.SIGN_IN.create({}),
    text: 'Already have an account?',
    buttonCopy: 'Sign In',
  },
  'workspace-settings': {
    link: routes.WORKSPACE_AGNOSTIC_SETTINGS_PEOPLE.create({}),
    text: null,
    buttonCopy: 'Back to Workspace',
  },
} as const

type HeaderLinkType =
  | 'sign-in'
  | 'sign-up'
  | 'none-with-border'
  | 'user-profile'
  | 'workspace-settings'

interface HeaderLinkProps {
  headerLink: HeaderLinkType
}

const HeaderLink: React.FC<HeaderLinkProps> = ({ headerLink }) => {
  const { state } = useLocation()

  if (headerLink === 'user-profile') {
    return <ConnectedUserDropdown />
  }

  if (headerLink === 'none-with-border') {
    return <></>
  }

  return (
    <>
      {headerLinkProps[headerLink].text && (
        <Text textStyle="copy.secondary.standard.D" mr={4}>
          {headerLinkProps[headerLink].text}
        </Text>
      )}
      <HeaderLinkButton
        variant="secondary-untinted"
        size="32"
        to={{
          pathname: headerLinkProps[headerLink].link,
          state,
        }}
      >
        {headerLinkProps[headerLink].buttonCopy}
      </HeaderLinkButton>
    </>
  )
}

export interface IndexLayoutHeaderProps {
  headerLink?: HeaderLinkType | 'none'
  blockLogoLink?: boolean
}

export const IndexLayoutHeader: React.FC<IndexLayoutHeaderProps> = ({
  headerLink,
  blockLogoLink,
}) => (
  <Header hasLink={headerLink !== 'none'}>
    <LogoWrapper data-testid="sketch-logo">
      {blockLogoLink ? (
        <Navbar.Logo variant="black" />
      ) : (
        <Link to={routes.ENTRY.create({})}>
          <Navbar.Logo variant="black" />
        </Link>
      )}
    </LogoWrapper>
    {headerLink && headerLink !== 'none' && (
      <Navbar.Section align="end">
        <HeaderLink headerLink={headerLink} />
      </Navbar.Section>
    )}
  </Header>
)
